import { memo } from 'react';
import { KeyboardLayouts } from '../../SimpleKeyboard/Layout';
import { isElectron } from '../../../helpers/EnvironmentFlags/EnvironmentFlags';
import { KioskFormZipCodeField } from './KioskFormZipCodeField/KioskFormZipCodeField';
import { WebFormZipCodeField } from './WebFormZipCodeField/WebFormZipCodeField';
import { FormZipCodeFieldProps } from './FormZipCodeField.types';

const FormZipCodeField = memo(({
    name,
    id,
    title,
    label,
    ariaLabel,
    disabled,
    required,
    autoFocus,
    keyboardLayout = KeyboardLayouts.NumberPad,
    shiftAfterSpace = false,
    shiftAfterPeriod = false,
    shiftAfterAmpersand = false,
    hideKeyboardOnClickOut = false,
    capsLock = false,
    fullWidth = false,
    seventyFivePercentWidth = false,
    tabFocusRefContext,
    onChangeCallback,
}: FormZipCodeFieldProps) => {
    return (
        isElectron() ? (
            <KioskFormZipCodeField
                name={name}
                id={id}
                title={title}
                label={label}
                ariaLabel={ariaLabel}
                disabled={disabled}
                required={required}
                autoFocus={autoFocus}
                keyboardLayout={keyboardLayout}
                shiftAfterSpace={shiftAfterSpace}
                shiftAfterPeriod={shiftAfterPeriod}
                shiftAfterAmpersand={shiftAfterAmpersand}
                hideKeyboardOnClickOut={hideKeyboardOnClickOut}
                capsLock={capsLock}
                fullWidth={fullWidth}
                seventyFivePercentWidth={seventyFivePercentWidth}
                tabFocusRefContext={tabFocusRefContext}
                onChangeCallback={onChangeCallback}
            />
        ) : (
            <WebFormZipCodeField
                name={name}
                id={id}
                title={title}
                label={label}
                ariaLabel={ariaLabel}
                disabled={disabled}
                required={required}
                autoFocus={autoFocus}
                capsLock={capsLock}
                fullWidth={fullWidth}
                seventyFivePercentWidth={seventyFivePercentWidth}
                tabFocusRefContext={tabFocusRefContext}
                onChangeCallback={onChangeCallback}
            />
        )
    );
});

export default FormZipCodeField;
